<template>
    <div class="container container-table">
        <div class="row vertical-10p">
            <div class="container">
                <div class="text-center col-sm-6 col-sm-offset-3">
                    <h1>Loading...</h1>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Logout',
        methods: {
            $_admin_logout () {
                console.log('Logout...')
                this.$store.commit('SET_USER', null)
                this.$store.commit('SET_TOKEN', null)

                if (window.localStorage) {
                    window.localStorage.setItem('user', null)
                    window.localStorage.setItem('token', null)
                }

                this.$router.push({name: 'login'})
            }
        },
        mounted () { this.$_admin_logout() }
    }
</script>


<style scoped>
    html, body, .container-table {
        height: 100%;
        /*background-color: #282B30 !important;*/
    }
    .container-table {
        display: table;
        color: black;
    }
    .vertical-center-row {
        display: table-cell;
        vertical-align: middle;
    }
    .vertical-20p {
        padding-top: 20%;
    }
    .vertical-10p {
        padding-top: 10%;
    }
    .logo {
        width: 15em;
        padding: 3em;
    }
    .loginForm .input-group {
        padding-bottom: 1em;
        height: 4em;
    }
    .input-group input {
        height: 4em;
    }
</style>



// WEBPACK FOOTER //
// Logout.vue?4e41f338